import { FieldDefinition, FieldBuilder, MenuCategories, MenuSubcategories, MENU_CATEGORY_KEY, MENU_SUBCATEGORY_KEY, MENU_NAME_SUFFIX } from '@zendra/shared';

import { VehicleTypeService } from '@general/proxy/general/controllers/vehicle-type.service';
import { VendorService } from '../proxy/controlling/controllers/vendor.service';
import { VehicleCategoryService } from '@general/proxy/general/controllers/vehicle-category.service';
FieldBuilder.setNamespace('Controlling');

export const LOGISTICSMAINTRUCKCOUNT_FIELDS: FieldDefinition[] = [
  FieldBuilder.number('quantity', 'Entity.LogisticsMainTruckCount.Quantity')
    .required()
    .build(),
  FieldBuilder.date('validSinceDate', 'Entity.LogisticsMainTruckCount.ValidSinceDate')
    .required()
    .build(),
  FieldBuilder.foreignKey('vehicleTypeId', 'Entity.VehicleType', VehicleTypeService)
    .display('name')
    .keyField('id')
    .build(),
  FieldBuilder.foreignKey('vendorId', 'Entity.Vendor', VendorService)
    .displayFromNested('vendor.fantasyName')
    .sortBy('vendor.fantasyName')
    .hideInChildForms()
    .build(),
  FieldBuilder.number('contractId', 'Entity.LogisticsMainTruckCount.ContractId')
    .build(),
  FieldBuilder.foreignKey('vehicleCategoryId', 'Entity.VehicleCategory', VehicleCategoryService)
    .required()
    .display('name')
    .keyField('id')
    .build(),
];

export const LOGISTICSMAINTRUCKCOUNT_CONFIG = {
  entityName: 'LogisticsMainTruckCount',
  localizationKey: 'Controlling::Entity.LogisticsMainTruckCount',
  fields: LOGISTICSMAINTRUCKCOUNT_FIELDS,
  permission: 'Controlling.LogisticsMainTruckCounts',
  showInMenu: true,
  menuCategory: MENU_CATEGORY_KEY + MenuCategories.Controlling + MENU_NAME_SUFFIX,
  menuSubcategory: MENU_SUBCATEGORY_KEY + MenuSubcategories.Contracts + MENU_NAME_SUFFIX,
};
